import type { ReactNode } from 'react';
import { PageSkeleton, useRoles } from '@deloitte-us-consulting/gp-sdk';
import AccessDenied from '../pages/AccessDenied';

/**
 * Route-level gate for a specific `Resource:Action` permission, e.g. the
 * `admin` role's `Registry:Manage` (ADR 0010) or `Rbac:Manage` (ADR 0012
 * decision 7a) and the platform-level `Ai:Manage`/`Data:Manage`/
 * `Email:Manage`/`Usage:Manage` (ADR 0041). `useRoles().can()` already ORs
 * in the platform-admin bypass, so a
 * `gp-admin` reaches these pages too without any extra check here.
 */
export function RequirePermission({
  permission,
  appId,
  children,
}: {
  permission: string;
  appId?: string;
  children: ReactNode;
}) {
  const { isLoading, can } = useRoles();
  if (isLoading) return <PageSkeleton label="Checking access…" />;
  if (!can(permission, appId !== undefined ? { appId } : undefined)) return <AccessDenied />;
  return <>{children}</>;
}
